import { Link, Stack, Typography } from '@mui/material';
import Logo from 'src/components/Logo';

const AuthWelcomeBanner: React.FC = () => {
  return (
    <Stack className="container" spacing={{ xs: 4, lg: 5.5 }}>
      <Logo sx={{ '& img': { height: 75 } }} />
      <Typography variant="title1">Towards a cooler planet.</Typography>
      <Typography>
        To learn more about how our carbon offset solution can support your business visit{' '}
        <Link target="_blank" href="https://carbonclick.com">
          www.carbonclick.com
        </Link>
        . It’s offsetting made simple.
      </Typography>
    </Stack>
  );
};

export default AuthWelcomeBanner;
